import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'hb-text-title',
  templateUrl: './text-title.component.html',
  styleUrls: ['./text-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextTitleComponent {
  @Input() text: string;
}
